<template>
  <el-dialog
    title="新增工作清单"
    :visible.sync="dialogVisible"
    width="1100px"
    :before-close="handleClose"
    :close-on-click-modal="false"
  >
    <el-form :model="form" ref="form" :rules="rules" label-width="90px">
      <!-- 单选按钮：合同外清单/合同内清单 -->
      <el-form-item label="清单类型" prop="listType">
        <el-radio-group v-model="form.listType">
          <el-radio label="outside">合同外清单</el-radio>
          <el-radio label="inside">合同内清单</el-radio>
        </el-radio-group>
      </el-form-item>

      <!-- 项目清单部分 -->
      <div style="font-size: 16px; font-weight: 600; padding: 10px 0">
        项目清单
      </div>
      <div>
        <el-row style="margin-top: 10px; margin-bottom: 10px" :gutter="24">
          <el-col :span="5">
            <div class="xingxing">工作项</div>
          </el-col>

          <el-col :span="3">
            <div class="xingxing">规格</div>
          </el-col>

          <el-col :span="3">
            <div class="xingxing">工程量</div>
          </el-col>
          <el-col :span="2">
            <div>单位</div>
          </el-col>
          <el-col :span="3">
            <div class="xingxing">单价（元）</div>
          </el-col>
          <el-col :span="2">
            <div>分项汇总</div>
          </el-col>
          <el-col :span="5">
            <div>备注</div>
          </el-col>
          <el-col :span="1">
            <div></div>
          </el-col>
        </el-row>
        <el-row
          v-for="(item, index) in form.itemList"
          :key="'workList' + index"
          :gutter="24"
        >
          <el-col :span="5">
            <el-form-item
              labelWidth="0"
              :rules="rules.workItemId"
              :prop="`itemList[${index}].workItemId`"
            >
              <el-select
                v-model="item.workItemId"
                placeholder="请选择"
                @change="changeWorkList($event, index)"
              >
                <el-option
                  v-for="item in workItemOptions"
                  :key="item.id"
                  :label="item.allName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item labelWidth="0">
              <el-select
                v-model="item.specId"
                placeholder="请选择规格"
                @change="changeChildrenList($event, index)"
                :disabled="!item.workItemId"
                clearable
              >
                <el-option
                  v-for="child in getSpecOptions(index)"
                  :key="child.id"
                  :label="child.specName || child.itemName"
                  :value="child.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item
              labelWidth="0"
              :rules="rules.quantity"
              :prop="`itemList[${index}].quantity`"
            >
              <el-input
                v-model="item.quantity"
                oninput="value=value.replace(/[^0-9.]/g,'')"
                placeholder="请输入工程量"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="2">
            <el-form-item labelWidth="0">
              <div>{{ item.workItemUnitName }}</div>
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item
              labelWidth="0"
              :rules="rules.price"
              :prop="`itemList[${index}].price`"
            >
              <el-input
                v-model="item.price"
                oninput="value=value.replace(/[^0-9.]/g,'')"
                placeholder="请输入单价"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="2">
            <el-form-item labelWidth="0">
              <div>￥{{ (item.quantity * item.price) | filterMoney }}</div>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item labelWidth="0" prop="remark">
              <el-input
                v-model="item.remark"
                placeholder="请输入备注"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="1">
            <li
              @click="deleteWorkList(index)"
              style="
                font-size: 20px;
                color: red;
                padding-top: 10px;
                cursor: pointer;
              "
              class="el-icon-remove"
            ></li>
          </el-col>
        </el-row>
      </div>
      <div
        style="border-bottom: 1px solid #ccc; width: 100%; padding-bottom: 20px"
      >
        <div style="float: right; height: 40px; line-height: 40px">
          总计：
          <span style="color: red">￥{{ allMoney }}</span>
        </div>
        <el-button type="primary" @click="addWorkList">
          添加项目内容
        </el-button>
        <el-button type="success" @click="exportToExcel"> 导出Excel </el-button>
        <el-button type="warning" @click="importExcel"> 导入Excel </el-button>
        <input
          type="file"
          ref="fileInput"
          accept=".xlsx, .xls"
          style="display: none"
          @change="handleFileChange"
        />
      </div>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="submit">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import ProjectApplyApi from "@/api/projectApply";
import * as XLSX from "xlsx";

export default {
  name: "AddNewItem",
  data() {
    return {
      dialogVisible: false,
      workItemOptions: [],
      form: {
        listType: "outside", // 默认为合同外清单
        itemList: [
          {
            amount: "",
            price: "",
            quantity: "",
            remark: "",
            workItemId: "",
            workItemName: "",
            workItemUnitName: "",
            specId: "",
            specName: "",
          },
        ],
      },
      rules: {
        listType: [
          {
            required: true,
            message: "请选择清单类型",
            trigger: ["blur", "change"],
          },
        ],
        workItemId: [
          {
            required: true,
            message: "请选择工作项",
            trigger: ["blur", "change"],
          },
        ],
        quantity: [
          {
            required: true,
            message: "请输入工程量",
            trigger: ["blur", "change"],
          },
        ],
        price: [
          {
            required: true,
            message: "请输入单价",
            trigger: ["blur", "change"],
          },
        ],
      },
    };
  },
  computed: {
    allMoney() {
      let sum = 0;
      this.form.itemList.forEach((item) => {
        if (!isNaN(item.quantity * item.price)) {
          sum += item.quantity * item.price;
        }
      });
      return sum;
    },
  },
  filters: {
    filterMoney(val) {
      if (isNaN(val)) {
        return 0;
      } else {
        return val;
      }
    },
  },
  methods: {
    // 打开弹窗
    open() {
      this.dialogVisible = true;
      this.getAllWorkLit();
    },
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.resetForm();
    },
    // 重置表单
    resetForm() {
      this.form = {
        listType: "outside",
        itemList: [
          {
            amount: "",
            price: "",
            quantity: "",
            remark: "",
            workItemId: "",
            workItemName: "",
            workItemUnitName: "",
            specId: "",
            specName: "",
          },
        ],
      };
      if (this.$refs.form) {
        this.$refs.form.resetFields();
      }
    },
    // 获取所有工作项
    getAllWorkLit() {
      ProjectApplyApi.queryAllWorkItem().then((res) => {
        if (res.data.code === 200) {
          this.workItemOptions = res.data.data.map((item) => {
            item.allName = item.workName + "-" + item.itemName;
            return item;
          });
        } else {
          this.$message({
            message: res.data.message,
            type: "error",
          });
        }
      });
    },
    // 工作项选择变化
    changeWorkList(value, index) {
      this.workItemOptions.forEach((item) => {
        if (value === item.id) {
          this.form.itemList[index].workItemId = item.id;
          this.form.itemList[index].workItemName = item.itemName;
          this.form.itemList[index].workItemUnitName = item.itemUnitName;
          // 清空规格选择
          this.form.itemList[index].specId = "";
          this.form.itemList[index].specName = "";
        }
      });
    },
    // 获取当前工作项的规格选项
    getSpecOptions(index) {
      const workItemId = this.form.itemList[index].workItemId;
      if (!workItemId) {
        return [];
      }
      const workItem = this.workItemOptions.find(
        (item) => item.id === workItemId
      );
      return workItem && workItem.children ? workItem.children : [];
    },
    // 处理规格选择变化
    changeChildrenList(value, index) {
      const workItemId = this.form.itemList[index].workItemId;
      if (!workItemId) {
        return;
      }
      // 处理规格清空的情况
      if (!value) {
        this.form.itemList[index].specId = "";
        this.form.itemList[index].specName = "";
        return;
      }
      const workItem = this.workItemOptions.find(
        (item) => item.id === workItemId
      );
      if (workItem && workItem.children) {
        const spec = workItem.children.find((child) => child.id === value);
        if (spec) {
          this.form.itemList[index].specId = spec.id;
          this.form.itemList[index].specName =
            spec.specName || spec.itemName || "";
        }
      }
    },
    // 添加项目内容
    addWorkList() {
      this.$set(this.form.itemList, this.form.itemList.length, {
        amount: "",
        price: "",
        quantity: "",
        remark: "",
        workItemId: "",
        workItemName: "",
        workItemUnitName: "",
        specId: "",
        specName: "",
      });
    },
    // 删除项目内容
    deleteWorkList(index) {
      if (this.form.itemList.length > 1) {
        this.form.itemList.splice(index, 1);
      } else {
        this.$message.warning("至少保留一项工作清单");
      }
    },
    // 提交表单
    submit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          // 计算每项的金额
          this.form.itemList.forEach((item) => {
            item.amount = item.price * item.quantity;
          });

          // 提交表单更新
          this.handleAddNewItemSubmit({
            listType: this.form.listType,
            itemList: this.form.itemList,
            total: this.allMoney,
          });
          // 关闭弹窗
          this.handleClose();
        } else {
          this.$message.error("请完善表单信息");
          return false;
        }
      });
    },
    // 处理新增工作清单提交
    handleAddNewItemSubmit(data) {
      // 这里可以添加提交数据的逻辑，例如调用API保存数据
      console.log("新增工作清单数据:", data);
      console.log("当前项目ID:", this.currentProjectId);

      // 示例：调用API保存数据（需要根据实际API进行调整）
      // ProjectApplyApi.addWorkItemList({
      //   projectId: this.currentProjectId,
      //   listType: data.listType,
      //   itemList: data.itemList,
      //   total: data.total,
      // }).then((res) => {
      //   if (res.data.code === 200) {
      //     this.$message.success('新增工作清单成功');
      //     this.queryProjectList(this.searchModel);
      //   } else {
      //     this.$message.error(res.data.message);
      //   }
      // });

      this.$message.success("新增工作清单成功");
      // this.dialogVisible = false;
      this.queryProjectList(this.searchModel);
    },
    // 导出Excel
    exportToExcel() {
      try {
        // 准备Excel数据
        const excelData = [];
        // 添加表头
        excelData.push([
          "工作项",
          "规格",
          "工程量",
          "单位",
          "单价（元）",
          "分项汇总",
          "备注",
        ]);

        // 添加数据行
        this.form.itemList.forEach((item) => {
          excelData.push([
            item.workItemName || "",
            item.specName || "",
            item.quantity || "",
            item.workItemUnitName || "",
            item.price || "",
            (item.quantity * item.price).toFixed(2) || "0.00",
            item.remark || "",
          ]);
        });

        // 添加总计行
        excelData.push([
          "",
          "",
          "",
          "",
          "总计：",
          this.allMoney.toFixed(2),
          "",
        ]);

        // 创建工作簿和工作表
        const ws = XLSX.utils.aoa_to_sheet(excelData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "工作清单");

        // 导出文件
        const fileName = `工作清单_${
          this.form.listType === "outside" ? "合同外" : "合同内"
        }_${new Date().getTime()}.xlsx`;
        XLSX.writeFile(wb, fileName);

        this.$message.success("导出Excel成功");
      } catch (error) {
        console.error("导出Excel失败:", error);
        this.$message.error("导出Excel失败，请重试");
      }
    },
    // 导入Excel
    importExcel() {
      // 触发文件选择
      this.$refs.fileInput.click();
    },
    // 处理文件选择变化
    handleFileChange(event) {
      const file = event.target.files[0];
      if (!file) return;

      // 重置文件输入，以便可以选择同一个文件
      this.$refs.fileInput.value = "";

      // 读取文件
      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, { type: "array" });

          // 获取第一个工作表
          const firstSheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[firstSheetName];

          // 将工作表转换为JSON数据
          const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

          if (jsonData.length < 2) {
            this.$message.error("Excel文件内容为空或格式不正确");
            return;
          }

          // 验证表头
          const headers = jsonData[0];
          const requiredHeaders = [
            "工作项",
            "规格",
            "工程量",
            "单位",
            "单价（元）",
            "分项汇总",
            "备注",
          ];

          // 检查表头是否匹配
          const headerErrors = [];
          requiredHeaders.forEach((header, index) => {
            if (!headers.includes(header)) {
              headerErrors.push(header);
            }
          });

          if (headerErrors.length > 0) {
            this.$message.error(
              `Excel表头不匹配，缺少以下字段：${headerErrors.join(", ")}`
            );
            return;
          }

          // 获取表头索引
          const headerIndexes = {};
          headers.forEach((header, index) => {
            if (requiredHeaders.includes(header)) {
              headerIndexes[header] = index;
            }
          });

          // 解析数据行
          const newItemList = [];
          let errorCount = 0;

          for (let i = 1; i < jsonData.length; i++) {
            const row = jsonData[i];

            // 跳过空行或总计行
            if (
              !row ||
              row.length === 0 ||
              (row[headerIndexes["工作项"]] === "" &&
                row[headerIndexes["规格"]] === "")
            ) {
              // 检查是否是总计行
              if (
                row &&
                row.length > 0 &&
                row[headerIndexes["单价（元）"]] === "总计："
              ) {
                continue;
              }
              continue;
            }

            // 提取数据
            const workItemName = row[headerIndexes["工作项"]] || "";
            const specName = row[headerIndexes["规格"]] || "";
            const quantity = row[headerIndexes["工程量"]] || 0;
            const unit = row[headerIndexes["单位"]] || "";
            const price = row[headerIndexes["单价（元）"]] || 0;
            const remark = row[headerIndexes["备注"]] || "";

            // 验证必填字段
            if (!workItemName || !quantity || !price) {
              errorCount++;
              continue;
            }

            // 查找工作项ID
            const workItem = this.workItemOptions.find(
              (item) =>
                item.itemName === workItemName || item.allName === workItemName
            );

            if (!workItem) {
              errorCount++;
              continue;
            }

            // 查找规格ID
            let specId = "";
            let specNameFinal = specName;

            if (specName && workItem.children && workItem.children.length > 0) {
              const spec = workItem.children.find(
                (child) =>
                  child.specName === specName || child.itemName === specName
              );
              if (spec) {
                specId = spec.id;
                specNameFinal = spec.specName || spec.itemName;
              }
            }

            // 添加到新列表
            newItemList.push({
              amount: "",
              price: parseFloat(price),
              quantity: parseFloat(quantity),
              remark: remark,
              workItemId: workItem.id,
              workItemName: workItemName,
              workItemUnitName: unit || workItem.itemUnitName,
              specId: specId,
              specName: specNameFinal,
            });
          }

          if (newItemList.length === 0) {
            this.$message.error("未找到有效数据，请检查Excel文件内容");
            return;
          }

          // 更新表单数据
          this.form.itemList = newItemList;

          // 显示导入结果
          let message = `成功导入 ${newItemList.length} 条数据`;
          if (errorCount > 0) {
            message += `，跳过 ${errorCount} 条无效数据`;
          }
          this.$message.success(message);
        } catch (error) {
          console.error("导入Excel失败:", error);
          this.$message.error("导入Excel失败，请检查文件格式是否正确");
        }
      };

      reader.readAsArrayBuffer(file);
    },
  },
};
</script>

<style lang="scss" scoped>
.el-form-item {
  margin-left: 0 !important;
}

.xingxing::before {
  content: "*";
  color: #f56c6c;
  margin-right: 4px;
}
</style>